import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastService } from 'src/app/core/toast.service';
import { GlobalService } from 'src/app/dao/global.service';
import { PedidoService } from 'src/app/dao/pedido.service';
import { Pedido } from 'src/app/model/pedido';

@Component({
  selector: 'app-estatistica',
  templateUrl: './estatistica.page.html',
  styleUrls: ['./estatistica.page.scss'],
})
export class EstatisticaPage implements OnInit {

  // tslint:disable-next-line: no-inferrable-types
  showSearch: boolean = false;
  pedidos: Pedido[] = [];
  pedido: Pedido;

  user: string;
  pass: string;

  data1: string;
  data2: string;

  dataAtual;
  dataMesPassado;

  tipoPedido = "todos";

  dataAtuaFormatada;
  dataMesPassadoFormatada;

  status = [];

  pedidosAbertos: Pedido[] = [];
  pedidosCancelados: Pedido[] = [];
  pedidosFinalizados: Pedido[] = [];
  pedidosEmissao: Pedido[] = [];
  pedidosProducao: Pedido[] = [];
  pedidosEntrega: Pedido[] = [];

  valorAbertos = 0;
  valorFechados = 0;
  valorFinalizados = 0;
  valorEntrega = 0;
  valorProducao = 0;
  valorEmissao = 0;
  valorCancelado = 0;
  valorTodos = 0;


  data: any;
  grafico: any;
  grafico2: any;
  mostrarData = false;
  tipoBuscames = true;
  tipoPesquisa = "mes";

  carregando = false;

  dataaux2;
  dataaux1;

  aberto;
  emissao;
  producao;
  entrega;
  finalizado;
  cancelado;
  status_selecionado = 1;
  status_string = "Abertos";
  loading = false;
  dataPesquisada = new Date().toISOString().split('T')[0];

  quantidade = 0;

  estilo;

  constructor(private route: ActivatedRoute,
    private toast: ToastService,
    private pedidoapi: PedidoService,
    private global: GlobalService) { }


  ngOnInit() {
    this.estilo = {
      "color": "red",
      "font-weight": "bold"
    }
    this.dataMesPassado = new Date();
    this.dataMesPassado.setMonth(this.dataMesPassado.getMonth() - 1);
    this.dataMesPassadoFormatada = this.dataMesPassado.toISOString().split('T')[0];

    this.dataAtual = new Date();
    this.dataAtuaFormatada = this.dataAtual.toISOString().split('T')[0];

    this.user = this.global.user;
    this.pass = this.global.pass;
    this.loadStatus();

    const idParam = this.route.snapshot.paramMap.get('tipo');
    if (idParam) {

      this.tipoPedido = idParam;
    }

    //this.loadPedidos(idParam);
    //this.loadPedidos();
  }

  ionViewWillEnter() {
    this.loadPedidos();
    this.data1 = this.dataAtuaFormatada;
    this.data2 = this.dataAtuaFormatada;
    this.user = this.global.user;
    this.pass = this.global.pass;
    this.loadStatus();
    if (this.dataPesquisada != null || this.dataPesquisada != '') {
      //this.dataPesquisa2(this.dataPesquisada);
    }

  }



  periodoPesquisa(periodo: any) {
    this.tipoPesquisa = periodo;
  }

  ativaDatas() {
    this.mostrarData = true;
  }

  desativaDatas() {
    this.mostrarData = false;
  }



   selectData(e:any){
    console.log(e);
    console.log(e.dataset);
    console.log(e.element);
    console.log(e.element._datasetIndex);
    console.log(e.element._index);
}


  async loadPedidos() {

    this.carregando = true

    this.valorAbertos = 0;
    this.valorFechados = 0;
    this.valorFinalizados = 0;
    this.valorEntrega = 0;
    this.valorProducao = 0;
    this.valorEmissao = 0;
    this.valorCancelado = 0;
    this.valorTodos = 0;

    this.loading = true;
    const dataAtual = this.dataAtuaFormatada.replace(/\-/gi, '');
    const mesPassado = this.dataMesPassadoFormatada.replace(/\-/gi, '');

    this.dataaux1 = dataAtual + '000000';



    switch (this.tipoPesquisa) {
      case "mes":
        this.dataaux1 = dataAtual + '235959';
        this.dataaux2 = mesPassado + '000000';
        break;

      case "hoje":
        this.dataaux1 = dataAtual + '235959';
        this.dataaux2 = dataAtual + '000000';
        break;

      case "personalizado":
        const data1aux = this.data1.replace(/\-/gi, '');
        const data2aux = this.data2.replace(/\-/gi, '');

        this.dataaux1 = data2aux + '235959';
        this.dataaux2 = data1aux + '000000';


        break;
    }



    for (let index = 0; index < 7; index++) {
      const element = index;

      await this.pedidoapi.getDataeParamGerenciar(this.dataaux2, this.dataaux1, index, this.tipoPedido).then(res => {
        if (element == 1) {
          this.pedidosAbertos = res;
        }

        if (element == 2) {
          this.pedidosEmissao = res;
        }

        if (element == 3) {
          this.pedidosProducao = res;
        }

        if (element == 4) {
          this.pedidosEntrega = res;
        }

        if (element == 5) {
          this.pedidosFinalizados = res;
        }

        if (element == 6) {
          this.pedidosCancelados = res;
        }
        this.loading = false;
      }).catch(async err => {
        console.log('err', err);
        this.loading = false;
        this.carregando = false
      });

    }

    this.quantidade = this.pedidosAbertos.length + this.pedidosEmissao.length + this.pedidosProducao.length + this.pedidosEntrega.length + this.pedidosFinalizados.length + this.pedidosCancelados.length;

    for (let index = 0; index < this.pedidosAbertos.length; index++) {
      const element = this.pedidosAbertos[index];
      this.valorAbertos = +element.total_pedido + +this.valorAbertos;
    }


    for (let index = 0; index < this.pedidosEmissao.length; index++) {
      const element = this.pedidosEmissao[index];
      this.valorEmissao = +element.total_pedido + +this.valorEmissao;
    }


    for (let index = 0; index < this.pedidosProducao.length; index++) {
      const element = this.pedidosProducao[index];
      this.valorProducao = +element.total_pedido + +this.valorProducao;
    }


    for (let index = 0; index < this.pedidosEntrega.length; index++) {
      const element = this.pedidosEntrega[index];
      this.valorEntrega = +element.total_pedido + +this.valorEntrega;
    }


    for (let index = 0; index < this.pedidosFinalizados.length; index++) {
      const element = this.pedidosFinalizados[index];
      this.valorFinalizados = +element.total_pedido + +this.valorFinalizados;
    }

    for (let index = 0; index < this.pedidosCancelados.length; index++) {
      const element = this.pedidosCancelados[index];
      this.valorCancelado = +element.total_pedido + +this.valorCancelado;

    }
    

    const datates = [this.pedidosAbertos.length, this.pedidosEmissao.length, this.pedidosProducao.length, this.pedidosEntrega.length, this.pedidosFinalizados.length, this.pedidosCancelados.length]
console.log(datates);


    this.grafico = {
      labels: ['Abertos', 'Em Emissão', 'Em Produção', 'Em Entrega', 'Finalizados', 'Cancelados'],
      datasets: [
        {
          data: [this.pedidosAbertos.length, this.pedidosEmissao.length, this.pedidosProducao.length, this.pedidosEntrega.length, this.pedidosFinalizados.length, this.pedidosCancelados.length],
          //data: [0, 5, 0],
          backgroundColor: [
            "#ef4128",
            "#fea53b",
            "#ffff01",
            "#6da951",
            "#4c6cb5",
            "#8d54a1"
          ],
          hoverBackgroundColor: [
            "#ef4128cf",
            "#fea53bcf",
            "#ffff01cf",
            "#6da951cf",
            "#4c6cb5cf",
            "#8d54a1cf"
          ]
        }]
    };


    this.valorTodos = this.valorAbertos + this.valorEmissao + this.valorProducao + this.valorEntrega + this.valorFinalizados + this.valorCancelado;

    if (this.valorTodos < 1) {
      this.valorTodos = 0;
    }

    this.grafico2 = {
      labels: ['Abertos', 'Em Emissão', 'Em Produção', 'Em Entrega', 'Finalizados', 'Cancelados'],
      datasets: [
        {
          data: [this.valorAbertos.toFixed(2), this.valorEmissao.toFixed(2), this.valorProducao.toFixed(2), this.valorEntrega.toFixed(2), this.valorFinalizados.toFixed(2), this.valorCancelado.toFixed(2)],
          //data: [0, 5, 0],
          backgroundColor: [
            "#ef4128",
            "#fea53b",
            "#ffff01",
            "#6da951",
            "#4c6cb5",
            "#8d54a1"
          ],
          hoverBackgroundColor: [
            "#ef4128cf",
            "#fea53bcf",
            "#ffff01cf",
            "#6da951cf",
            "#4c6cb5cf",
            "#8d54a1cf"
          ]
        }]
    };

    this.carregando = false;
  }


  gerarPdf() {
  }

  alterarFiltro(param) {
    this.carregando = true;
    this.loading = true;
    switch (param) {
      case 1: this.status_string = "Abertos";
        break;

      case 2: this.status_string = "Em Emissão";
        break;

      case 3: this.status_string = "Em Produção";
        break;

      case 4: this.status_string = "Em Entrega";
        break;

      case 5: this.status_string = "Finalizados";
        break;

      case 6: this.status_string = "Cancelados";
        break;
    }

    this.status_selecionado = param;

    const dataAux = this.data1.replace(/\-/gi, '');
    this.data2 = this.data1.replace(/\-/gi, '');

    this.data2 += '235959';
    const dataAux1 = dataAux + '000000';

    this.pedidoapi.getDataeParamGerenciar(dataAux1, this.data2, this.status_selecionado, this.tipoPedido).then(res => {
      this.pedidos = res;
      this.quantidade = res.length;
      if (res.length < 0 || res.length === null) {
        this.quantidade = 0;
      }
      this.loading = false;
      this.carregando = false;
    }).catch(async err => {
      console.log('err', err);
      this.quantidade = 0;
      this.loading = false;
      this.carregando = false;
      //this.toast.showError('Erro ao obter Histórico');
    });
  }


  async loadStatus() {
    this.pedidoapi.getStatus().then(res => {
      this.status = res;
      for (let index = 0; index < this.status.length; index++) {
        const element = this.status[index];

        if (element.id === 1) {
          this.aberto = true;
        }

        if (element.id === 5) {
          this.finalizado = true;
        }

        if (element.id === 6) {
          this.cancelado = true;
        }

      }


    }).catch(async err => {
      console.log('err', err);
      //this.toast.showError('Erro ao obter Histórico');
    });
  }

  dataPesquisa($event: any) {
    this.loading = true;
    this.carregando = true;
    const value = $event.target.value;

    this.dataPesquisada = value;

    //const dataAux = value.replace(/\-/gi, '');
    //this.data2 = value.replace(/\-/gi, '');

    this.data2 = this.data2.replace(/\-/gi, '');
    this.data1 = this.data1.replace(/\-/gi, '');


    this.data2 += '235959';
    this.data1 += '000000';

    this.pedidoapi.getDataeParamGerenciar(this.data1, this.data2, 1, "todos").then(res => {
      this.pedidos = res;
      this.quantidade = res.length;
      if (res.length < 0 || res.length === null) {
        this.quantidade = 0;
      }
      this.loading = false;
      this.carregando = false;
    }).catch(async err => {
      console.log('err', err);
      this.quantidade = 0;
      this.loading = false;
      this.carregando = false;
      //this.toast.showError('Erro ao obter Histórico');
    });
  }

  searchButtonClick() {
    this.showSearch = true;
  }

  doSearchBarCancel() {
    this.showSearch = false;
    //this.loadPedidos(this.tipoPedido);
    this.loadPedidos();
  }

  async doSearchBarChange($event: any) {
    const value = $event.target.value;
    this.pedidos = await this.pedidoapi.GetByNome(value);
  }


}
